/* eslint-disable */
import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';
import $ from 'jquery';
import promise from 'bluebird';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import uuid from '@bingads-webui-component-legacy/uuid/index';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import ViewModel from '@bingads-webui-campaign-legacy/crud-adgroup/viewmodel/update';
import tmpl from '@bingads-webui-campaign-legacy/crud-adgroup/template/update.pug';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var View = Backbone.View.extend({
  events: {
    'click .glyphicon.glyphicon-remove': 'delete',
    'show.bs.collapse': 'show',
    'hide.bs.collapse': 'hide',
    'click .adgroup-name': 'selectThisAdGroup'
  },
  className: 'row',
  initialize: function (options) {
    var self = this;
    self.options = options || ({});
    self.adapter = {
      adapter: self.options.adapter || 'bulk'
    };
    self.ko_model = new ViewModel(self.options);
    self.hasChanges = true;
    self.ko_model.Name.subscribe(function () {
      self.hasChanges = true;
      self.ko_model.shouldValidateName(true);
      self.trigger('nameChanged', self);
    });
    self.deletedConfirmationTimeout = 3000;
  },
  selectThisAdGroup: function () {
    this.trigger('selectThisAdGroup', this);
  },
  show: function (e) {
    this.ko_model.isOpen(true);
    this.trigger('show', this, e);
  },
  hide: function (e) {
    if (!this.validate() || this.ko_model.isOnlyAdGroup()) {
      e.preventDefault();
      return false;
    }
    this.save();
    this.ko_model.isOpen(false);
    return true;
  },
  collapse: function (operation) {
    this.$('.ad-group-collapsible').collapse(operation);
  },
  render: function () {
    this.$el.html(tmpl({
      i18n: i18n,
      uuid: uuid
    }));
    ko.applyBindings(this.ko_model, this.el);
    this.subView.render();
    this.$('.ad-group-collapsible').append(this.subView.el);
    return this;
  },
  create: function (newAdGroup) {
    var self = this;
    self.ko_model.errors.clear(i18nErrors.isCampaignApiError);
    self.ko_model.isWaitingForSaveResponse(true);
    var blocker = withUiBlock();
    return jsdata.AdGroup.create(newAdGroup, self.adapter).then(function (data) {
      if (!_.isEmpty(data.Id)) {
        self.updateViewModels(data);
        if (self.options.instrumentation) {
          self.options.instrumentation.instrument('create', data);
        }
        if (self.options.activityLogger) {
          self.options.activityLogger.signal('1', `create adgroup | type: ${_.result(newAdGroup, 'AdGroupType')}`);
        }
      }
    }).catch(function (errors) {
      self.updateViewModelsOnError(errors);
    }).finally(function () {
      blocker();
      self.ko_model.isWaitingForSaveResponse(false);
    });
  },
  showErrors: function (errors) {
    self.ko_model.errors.add(i18nErrors.getODataErrors(errors));
  },
  update: function (adGroupToUpdate) {
    var self = this;
    self.ko_model.errors.clear(i18nErrors.isCampaignApiError);
    self.ko_model.isWaitingForSaveResponse(true);
    return jsdata.AdGroup.update(self.ko_model.Id(), adGroupToUpdate, self.adapter).then(function (data) {
      self.updateViewModels(data);
      if (self.options.instrumentation) {
        self.options.instrumentation.instrument('update', data);
      }
      if (self.options.activityLogger) {
        self.options.activityLogger.signal('1', `update adgroup | type: ${_.result(adGroupToUpdate, 'AdGroupType')}`);
      }
    }).catch(function (errors) {
      self.updateViewModelsOnError(errors);
    }).finally(function () {
      self.ko_model.isWaitingForSaveResponse(false);
    });
  },
  delete: function () {
    var self = this;
    self.ko_model.errors.clear(i18nErrors.isCampaignApiError);
    self.ko_model.isWaitingForSaveResponse(true);
    if (_.isNaN(self.ko_model.Id()) || self.ko_model.Id() < 1) {
      self.confirmDelete(self);
      return promise.resolve({
        'success': true
      });
    } else {
      self.ko_model.isWaitingForSaveResponse(true);
      var deleteParams = _.extend(self.adapter, {
        parentId: self.ko_model.Campaign().Id
      });
      var blocker = withUiBlock(this.$el);
      return jsdata.AdGroup.destroy(self.ko_model.Id(), deleteParams).then(function (data) {
        self.confirmDelete(self);
        if (self.options.instrumentation) {
          self.options.instrumentation.instrument('delete', data);
        }
        if (self.options.activityLogger) {
          self.options.activityLogger.signal('1', 'delete adgroup');
        }
      }).catch(function (response) {
        self.ko_model.errors.add(i18nErrors.getBulkApiErrors(response.errors));
      }).finally(function () {
        self.ko_model.isWaitingForSaveResponse(false);
        blocker();
      });
    }
  },
  confirmDelete: function (self) {
    self.trigger('delete', self);
    self.ko_model.isDeleted(true);
    setTimeout(self.remove.bind(self), self.deletedConfirmationTimeout);
  },
  save: function () {
    if (!this.validate()) {
      return promise.resolve({
        isValid: false,
        success: true
      });
    }
    var changes = this.getChanges();
    if (!_.isNull(changes)) {
      if (_.isNaN(this.ko_model.Id()) || this.ko_model.Id() < 1) {
        return this.create(changes);
      } else {
        return this.update(changes);
      }
    }
    return promise.resolve({
      isValid: true,
      success: true
    });
  },
  updateCampaign: function () {
    var editableFields = ['StartDate', 'EndDate'];
    var contextCampaign = this.options.context.get('Campaign');
    _.each(editableFields, function (field) {
      if (this.ko_model[field]() !== contextCampaign[field]) {
        this.ko_model[field](contextCampaign[field]);
        this.hasChanges = true;
      }
    }, this);
  },
  validateViewModel: function () {
    var isValid = this.ko_model.validate();
    if (!isValid) {
      _.each(this.ko_model.properties, function (field) {
        if (!this.ko_model[field].isValid()) {
          if (this.options.activityLogger) {
            this.options.activityLogger.signal('ad group field invalid: ' + field, 'create ad group');
          }
        }
      }, this);
    }
    return isValid;
  },
  validate: function () {
    var viewHasChanges = this.hasChanges;
    this.ko_model.shouldValidateName(true);
    var hasDuplicateNames = this.ko_model.isNameDuplicate();
    if (hasDuplicateNames && this.options.activityLogger) {
      this.options.activityLogger.signal('ad group field invalid: has duplicate names', 'create ad group');
    }
    var isValid = this.validateViewModel() && !hasDuplicateNames;
    isValid = this.subView.validate() && isValid;
    this.hasChanges = viewHasChanges;
    return isValid;
  },
  updateViewModels: function (data) {
    this.ko_model.errors.clear(i18nErrors.isCampaignApiError);
    if (_.isNaN(this.ko_model.Id()) || this.ko_model.Id() < 1) {
      this.ko_model.Id(Number(data.Id));
    }
    this.hasChanges = false;
  },
  updateViewModelsOnError: function (response, subEntity) {
    this.ko_model.errors.clear(i18nErrors.isCampaignApiError);
    i18nErrors.getPartial(response, [subEntity]);
    if (this.options.activityLogger && response && response.errors) {
      _.chain(response.errors).map(function (error) {
        return error.Error;
      }).uniq().each(function (error) {
        this.options.activityLogger.signal(error, 'adgroup creation api error');
      }, this);
    }
    if (!_.isEmpty(response.entity.errors)) {
      this.ko_model.errors.add(response.entity.errors);
    } else {
      this.hasChanges = false;
    }
    if (_.isUndefined(response.entity.Id)) {
      return;
    }
    if (_.isNaN(this.ko_model.Id()) || this.ko_model.Id() < 1) {
      this.ko_model.Id(Number(response.entity.Id));
    }
  }
});
export default View;

